import { round } from "@turf/turf";
import React, { useState, useCallback } from "react";
import { Marker, Popup } from "react-map-gl/mapbox";

const GPSTrackPositionMarker = ({ coordinates, markerName }) => {
  const [showPopup, setShowPopup] = useState(false);

  const handleMarkerClick = useCallback((e) => {
    e.originalEvent.stopPropagation(); // evita que el mapa se mueva
    setShowPopup((prev) => !prev);
  }, []);

  const handleClosePopup = useCallback(() => {
    setShowPopup(false);
  }, []);

  return (
    <>
      <Marker
        longitude={coordinates.longitude}
        latitude={coordinates.latitude}
        anchor="center"
        onClick={handleMarkerClick}
      >
        <div
          className="w-5 h-5 rounded-full border-2 border-white shadow-lg cursor-pointer"
          style={{ backgroundColor: coordinates.color }}
          title={markerName}
        />
      </Marker>

      {showPopup && (
        <Popup
          longitude={coordinates.longitude}
          latitude={coordinates.latitude}
          anchor="top"
          closeButton={false}
          closeOnClick={false}
          onClose={handleClosePopup}
          offset={15}
          className=""
        >
          <div className="">
            <strong className="text-sm">{markerName}</strong>
              <ul className="list-none text-xs">
                <li>Lat: {coordinates.latitude}</li>
                <li>Lon: {coordinates.longitude}</li>
                <li>Sat: {coordinates.satelliteCount}</li>
                <li>Speed: {coordinates.speed} km</li>
              </ul>
          </div>
        </Popup>
      )}
    </>
  );
};

export default GPSTrackPositionMarker;
